import React from 'react';
import styles from './commonComponents.module.scss';

export default function PRJPlate() {
  return <div className={styles.project_plate}>PRJ</div>;
}
